var portfolioDelete = {
	title: "Löschen des virtuellen Portfolios",
	nameInputLabel: "Portfolioname",
	alertHeading: "Möchten Sie das virtuelle Portfolio wirklich löschen?",
	alertBody: "Wenn ja, klicken Sie auf Ok. Bitte beachten Sie, dass gelöschte Portfolios nicht wiederhergestellt werden können.",
	confirmBtn: "Ok",
	cancelBtn: "Abbrechen"
};
var de = {
	portfolioDelete: portfolioDelete
};

export { de as default, portfolioDelete };
